import { Component, OnDestroy, OnInit } from '@angular/core'
import { MatDialog } from '@angular/material/dialog'
import { AddSubtractFundPopupComponent } from '../../components/add-subtract-fund-popup/add-subtract-fund-popup.component'
import { TranslateService } from '@ngx-translate/core'
import {
	addSubtractPayloadModel,
	spWalletAmount,
} from 'src/app/modules/wallet/models/wallet.models'
import { ActivatedRoute } from '@angular/router'
import { SharedService } from 'src/app/shared/services/shared.service'
import { WalletService } from '../../services/wallet.service'
import { Subscription } from 'rxjs'
import { PayoutService } from 'src/app/modules/payout/services/payout.service'
import { BranchPayoutMethod } from 'src/app/modules/payout/models/sp-payout.models'

@Component({
	selector: 'app-sp-wallet',
	templateUrl: './sp-wallet.component.html',
	styleUrls: ['./sp-wallet.component.scss'],
})
export class SpWalletComponent implements OnInit, OnDestroy {
	showFilter: boolean = true
	refresh: boolean = true
	filterCount: number = 0
	addSubtractDetails: addSubtractPayloadModel = {
		actorId: 0,
		currencyId: 0,
		amount: 0,
		reason: '',
		actor: 2,
	}

	walletAmount!: spWalletAmount
	subscription: Subscription = new Subscription()
	constructor(
		private dialog: MatDialog,
		public translate: TranslateService,
		private ActivatedRoute: ActivatedRoute,
		private SharedService: SharedService,
		private WalletService: WalletService,
		private payoutService: PayoutService
	) {}

	ngOnInit(): void {
		this.SharedService.headerTitle.next(`WALLET.WALLET_LIST.PAGE_TITLE`)
		this.addSubtractDetails.actorId = +this.ActivatedRoute.snapshot.params.id

		this.SharedService.handleBreadCrumb('wallet', false, {
			name: '',
			id: this.addSubtractDetails.actorId,
			url: '/layout/wallet/sp-wallet',
			queryParams: this.addSubtractDetails.actorId,
		})
		this.getWalletDetails()
	}
	addSubtractFund(
		image?: string,
		type?: string,
		currentAmount?: number | null,
		currency?: any
	) {
		this.dialog
			.open(AddSubtractFundPopupComponent, {
				width: '585px',
				data: {
					image: `assets/images/${image}`,
					type: type,
					SP: true,
					currentAmount: type == 'sub' ? currentAmount : null,
					currency: currency,
				},
				autoFocus: false,
			})
			.afterClosed()
			.subscribe({
				next: (res) => {
					if (res) {
						this.addSubtractDetails = { ...this.addSubtractDetails, ...res }

						type == 'add'
							? this.spAddFund(this.addSubtractDetails)
							: this.spSubtractFund(this.addSubtractDetails)
					}
				},
			})
	}

	getWalletDetails() {
		this.subscription.add(
			this.WalletService.getSpWalletData(
				this.addSubtractDetails.actorId
			).subscribe((res: any) => {
				this.walletAmount = res.result

				this.addSubtractDetails.currencyId = this.walletAmount?.currency?.id
			})
		)
	}

	spAddFund(body: addSubtractPayloadModel) {
		this.subscription.add(
			this.WalletService.addFundToWallet(body).subscribe({
				next: (res) => (res ? this.getWalletDetails() : ''),
				complete: () => {
					this.refresh = !this.refresh
				},
			})
		)
	}
	spSubtractFund(body: addSubtractPayloadModel) {
		this.subscription.add(
			this.WalletService.subtractFundFromWallet(body).subscribe({
				next: (res) => (res ? this.getWalletDetails() : ''),
				complete: () => {
					this.refresh = !this.refresh
				},
			})
		)
	}

	ngOnDestroy(): void {
		this.subscription.unsubscribe()
	}
}
